module.exports = __webpack_public_path__ + "static/media/error.cddd8b65.svg";